import React, { Component } from 'react';
import { ReactComponent as MyMapsList } from './images/my-maps.svg';
import './MyMapsItems.css';

class MyMapsItems extends Component {
  state = {};

  render() {
    return (
      <div className="fs-container fs-mymaps-item-container">
        <div className="fs-mymaps-items-container-header">
          <div className="my-maps-header">
            <MyMapsList style={{ height: '20px' }} />
            <h3 className="my-maps-title">Moje mape</h3>
            <label
              className={
                this.props.isEditing
                  ? 'fs-mymaps-items-container-header-editing'
                  : 'fs-hidden'
              }
            >
              Uključeno uređivanje
            </label>
          </div>
        </div>
        <div
          className={
            this.props.children.props.children.length === 0
              ? 'fs-mymaps-items-no-data'
              : 'fs-hidden'
          }
        >
          Trenutno nema stavki za prikaz. Koristite alate za crtanje kako biste
          kreirali mapu.
        </div>
        <div className="fs-mymaps-items-container-list">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default MyMapsItems;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
